/* unplugin-vue-components disabled */import { render } from "./home_imageshow.vue?vue&type=template&id=64ab3075&scoped=true"
import script from "./home_imageshow.vue?vue&type=script&lang=js"
export * from "./home_imageshow.vue?vue&type=script&lang=js"

import "./home_imageshow.vue?vue&type=style&index=0&id=64ab3075&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ab3075"]])

export default __exports__